import React, { Component } from 'react'
import Aux from '../../../../hoc/Auxiliary/Auxiliary'

import {
  Grid,
  Container,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core/'

import Alert from '../../../Alert/Alert'
import GradeTable from './Table/GradeTable'
import ForceRankTable from './Table/ForceRankTable'
import GradeChart from './Chart/GradeChart'
import ForceRankChart from './Chart/ForceRankChart'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

class ForceRankPageContent extends Component {
  state = {
    gradeData: [],
    data: [],
    validForceRank: false,
    saveGrade: [],
    adjust_grade: [],
    valid: false,
    save: false,
    adjustData: [],
    openDialog: false,
    checkGrade: false
  }

  inputAdjustChange = data => {
    this.setState({
      data: data
    })
  }

  inputGradeChange = (data, amount) => {
    let valid = false
    let sum = 0
    let grade = []
    let saveGrade = []

    data.map(item => {
      sum = sum + item.amount
      grade.push(item.amount)
      return item
    })
    if (sum === amount) {
      valid = true
      saveGrade = {
        grade: grade,
        amount_grade: amount
      }
    }
    this.setState({
      gradeData: data,
      validForceRank: valid,
      saveGrade: saveGrade
    })
  }

  adjustGradeChange = data => {
    this.setState({
      adjust_grade: data
    })
  }

  saveGrade = () => {
    let data_force_rank = []
    let data_adjust = []
    let dataAd = {}

    this.state.gradeData.map(item => {
      data_force_rank.push({
        company_id: this.props.filterControls.company_id.value.value,
        org_id: this.props.filterControls.org_id.value.value,
        form_id: this.props.filterControls.form_id.value.value,
        grade_id: item.value_list_id,
        budget_percent: item.budget,
        budget_emp: item.amount
      })
      return {
        data_force_rank
      }
    })

    this.state.data.map(item => {
      this.state.gradeData.map(grade => {
        if (grade.value_list_name === item.grade) {
          dataAd = {
            ...dataAd,
            result_id: item.result_id,
            grade_code: grade.value_list_code
          }
        }
        if (grade.value_list_name === item.adjust_grade) {
          dataAd = {
            ...dataAd,
            result_id: item.result_id,
            grade_adjust_code: grade.value_list_code
          }
        }
        return grade
      })
      data_adjust.push(dataAd)
      return item
    })

    let saveData = { data_force_rank: data_force_rank, data_adjust: data_adjust }
    this.props.createForceRank(saveData)
  }

  handleCancel = () => {
    window.location.reload(false)
  }

  forceRank = () => {
    const param = {
      ...this.state.saveGrade,
      company_id: this.props.filterControls.company_id.value.value,
      form_id: this.props.filterControls.form_id.value.value,
      org_id: this.props.filterControls.org_id.value.value
    }
    this.props.fetchForceRankList(param)
    this.handleClose()
    this.setState({
      save: true
    })
  }

  handleClickOpen = () => {
    if (this.props.adjustData.force_rank_budget.length !== 0) {
      this.setState({ openDialog: true })
    } else {
      let param = {
        ...this.state.saveGrade,
        company_id: this.props.filterControls.company_id.value.value,
        form_id: this.props.filterControls.form_id.value.value,
        org_id: this.props.filterControls.org_id.value.value
      }
      this.props.fetchForceRankList(param)
      this.setState({
        save: true
      })
    }
  }

  handleClose = () => {
    this.setState({ openDialog: false })
  }

  checkGrade = checkGrade => {
    this.setState({ checkGrade })
  }

  render() {
    return (
      <Aux>
        <Alert />
        <Paper
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            backgroundColor: '#DDDDDD',
            padding: '10px',
            marginBottom: '15px'
          }}>
          {this.state.validForceRank ? (
            <Button
              variant='contained'
              disabled={false}
              style={{ color: 'white', backgroundColor: '#FFCC00', fontWeight: 'bold' }}
              onClick={this.handleClickOpen}>
              {this.props.translate('AdjustGrade')}
            </Button>
          ) : (
            <Button
              variant='contained'
              disabled={true}
              style={{ color: 'white', fontWeight: 'bold' }}
              onClick={this.handleClickOpen}>
              {this.props.translate('AdjustGrade')}
            </Button>
          )}
        </Paper>
        <Dialog
          open={this.state.openDialog}
          onClose={this.handleClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'>
          <DialogTitle id='alert-dialog-title'>{this.props.translate('ForceRankTab')}</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {this.props.translate('confirmClearGrade')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant='outlined'
              onClick={() => {
                this.forceRank()
              }}>
              {this.props.translate('confirm')}
            </Button>
            <Button
              variant='outlined'
              onClick={() => {
                this.handleClose()
              }}
              autoFocus>
              {this.props.translate('cancel')}
            </Button>
          </DialogActions>
        </Dialog>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <GradeTable
              gradeData={this.state.gradeData}
              grade={(data, amount) => this.inputGradeChange(data, amount)}
              adjustData={this.props.adjustData}
              filterControls={this.props.filterControls}
              fetchForceRankList={param => {
                this.props.fetchForceRankList(param)
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <GradeChart gradeData={this.state.gradeData} />
          </Grid>
          <Grid item xs={12} md={4}>
            <ForceRankChart
              gradeData={this.state.gradeData}
              adjust_grade={this.state.adjust_grade}
              adjustData={this.props.adjustData}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <ForceRankTable
              data={this.props.data}
              loading={this.props.loading}
              adjust_grade={data => this.adjustGradeChange(data)}
              valid={valid => this.setState({ valid: valid })}
              dataAdjust={data => this.inputAdjustChange(data)}
              adjustData={this.props.adjustData}
              gradeData={this.state.gradeData}
              fetchForceRankList={param => {
                this.props.fetchForceRankList(param)
              }}
              checkGrade={this.checkGrade}
              // checkGrade={checkGrade => {
              //   this.setState({ checkGrade: checkGrade })
              // }}
              // checkGrade={checkGrade => {
              //   this.checkGrade(checkGrade)
              // }}
              // checkGrade={grade => {
              //   this.setState({ checkGrade: grade })
              // }}
              // valid_count={valid_count => this.setState({ valid_count: valid_count })}
            />
          </Grid>
        </Grid>

        {this.state.save && this.state.checkGrade ? (
          <p style={{ color: 'red' }}>{this.props.translate('alertGrade')}</p>
        ) : null}
        {this.props.data.length !== 0 ? (
          <Container
            component={'div'}
            style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
            <Button
              onClick={() => this.saveGrade()}
              disabled={!(this.state.save && !this.state.checkGrade)}
              variant='contained'
              color='primary'
              style={{ marginRight: '10px' }}>
              {this.props.translate('save')}
            </Button>
            <Button
              variant='contained'
              onClick={() => {
                this.handleCancel()
              }}>
              {this.props.translate('cancel')}
            </Button>
          </Container>
        ) : null}
      </Aux>
    )
  }
}

export default withTranslate(ForceRankPageContent)
